import { type Selector } from 'react-redux';
import { type Reducer } from 'redux';
import type { ValueOf } from 'type-fest';

import { DETAILS_SETTINGS_MODAL_TYPES } from 'constants/all';

import { type RootState } from 'store/configureStore';

import { ACTION_TYPES } from './actions';

type DetailsSettingsModalState = {
  isModalOpen: boolean;
  isMultipleItems: boolean;
  mode: ValueOf<typeof DETAILS_SETTINGS_MODAL_TYPES> | null;
  filenames: string[];
};

const initialState = {
  isModalOpen: false,
  isMultipleItems: false,
  mode: null,
  filenames: [],
} satisfies DetailsSettingsModalState;

/* eslint-disable default-param-last */
export const detailsSettingsModalReducer: Reducer<DetailsSettingsModalState> = (
  state = initialState,
  action,
) => {
  /* eslint-enable default-param-last */

  const { payload } = action;
  switch (action.type) {
    case ACTION_TYPES.detailsSettingsModalOpen:
      return {
        ...state,
        isModalOpen: true,
        isMultipleItems: payload.isMultipleItems,
        mode: payload.mode,
        filenames: payload.filenames,
      };
    case ACTION_TYPES.detailsSettingsModalConfirm:
    case ACTION_TYPES.detailsSettingsModalClose:
      return {
        ...state,
        isModalOpen: false,
      };
    default:
      return state;
  }
};

export const getScope = (state: RootState): DetailsSettingsModalState =>
  state.modules.common.modals.detailsSettingsModal;

export const getIsMultipleItems: Selector<
  RootState,
  DetailsSettingsModalState['isMultipleItems']
> = (state) => getScope(state).isMultipleItems;

export const getIsModalOpen: Selector<
  RootState,
  DetailsSettingsModalState['isModalOpen']
> = (state) => getScope(state).isModalOpen;

export const getMode: Selector<RootState, DetailsSettingsModalState['mode']> = (
  state,
) => getScope(state).mode;

export const getFilenames: Selector<
  RootState,
  DetailsSettingsModalState['filenames']
> = (state) => getScope(state).filenames;
